import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-240dd508"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Reporting & Process Continuity\n          ")
], -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n            Does the employee have any people reporting to them? *\n          ", -1));
const _hoisted_5 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_6 = { class: "mt-4 space-y-4" };
const _hoisted_7 = { class: "flex items-start" };
const _hoisted_8 = { class: "h-5 flex items-center" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employee_reporting_to",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_11 = { class: "flex items-start" };
const _hoisted_12 = { class: "h-5 flex items-center" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employee_reporting_to",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm mt-4" }, "\n            *If the leaver has MMS and has other employees directly reporting\n            into them in SAP please select Yes.\n          ", -1));
const _hoisted_16 = { key: 0 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-blue-700" }, "\n            Please provide information as to who the people will report to\n            moving forward or in the interim period below:\n          ", -1));
const _hoisted_18 = { class: "col-span-6 mt-2" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employee-name",
    class: "block text-sm font-medium text-gray-700"
}, "New line manager name *", -1));
const _hoisted_20 = ["disabled"];
const _hoisted_21 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_22 = { class: "col-span-6 mt-2" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "employee-name",
    class: "block text-sm font-medium text-gray-700"
}, "New line manager employee number *", -1));
const _hoisted_24 = ["disabled"];
const _hoisted_25 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_26 = { class: "col-span-6 mt-2" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "additional_information",
    class: "block text-sm font-medium text-gray-700"
}, "Additional information:", -1));
const _hoisted_28 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_29 = ["disabled"];
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-sm mt-2" }, "\n            *Once submitted / approved this information will be sent to the SSC\n            Data Management Team who will update SAP.\n          ", -1));
const _hoisted_31 = { class: "mt-2" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n            Is the leaver a coupa user? *\n          ", -1));
const _hoisted_33 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_34 = { class: "mt-4 space-y-4" };
const _hoisted_35 = { class: "flex items-start" };
const _hoisted_36 = { class: "h-5 flex items-center" };
const _hoisted_37 = ["disabled"];
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employee_reporting_to",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_39 = { class: "flex items-start" };
const _hoisted_40 = { class: "h-5 flex items-center" };
const _hoisted_41 = ["disabled"];
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "coupa_user",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_43 = { key: 1 };
const _hoisted_44 = { class: "col-span-6 mt-2" };
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "coupa_user_name",
    class: "block text-sm font-medium text-gray-700"
}, "Name of the user to re-assign responsibilities to: *", -1));
const _hoisted_46 = ["disabled"];
const _hoisted_47 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_48 = { class: "col-span-6 mt-2" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "coupa_user_number",
    class: "block text-sm font-medium text-gray-700"
}, "Payroll number of the user to re-assign responsibilities to:\n              *", -1));
const _hoisted_50 = ["disabled"];
const _hoisted_51 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_52 = { class: "col-span-6 mt-2" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "coupa_user_email",
    class: "block text-sm font-medium text-gray-700"
}, "Email of the user to re-assign responsibilities to: *", -1));
const _hoisted_54 = ["disabled"];
const _hoisted_55 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_56 = { class: "mt-2" };
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n            Is this leaver an operational engineer within a CAFM System? *\n          ", -1));
const _hoisted_58 = { class: "mt-4 space-y-4" };
const _hoisted_59 = { class: "flex items-start" };
const _hoisted_60 = { class: "h-5 flex items-center" };
const _hoisted_61 = ["disabled"];
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "cafm_leaver_yes",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_63 = { class: "flex items-start" };
const _hoisted_64 = { class: "h-5 flex items-center" };
const _hoisted_65 = ["disabled"];
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "cafm_leaver_no",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_67 = {
    key: 0,
    class: "col-span-6 mt-2"
};
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "cafm_leaver_contracts",
    class: "block text-sm font-medium text-gray-700"
}, "Which contracts do they work on?: *", -1));
const _hoisted_69 = ["disabled"];
const _hoisted_70 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_71 = {
    key: 1,
    class: "col-span-6 mt-4"
};
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "designated_operative",
    class: "block text-sm font-medium text-gray-700"
}, "Is there a designated operative to cover this leaver's work?: *\n              ", -1));
const _hoisted_73 = { class: "flex items-start mt-4" };
const _hoisted_74 = { class: "h-5 flex items-center" };
const _hoisted_75 = ["disabled"];
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "designated_operative_yes",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_77 = { class: "flex items-start" };
const _hoisted_78 = { class: "h-5 flex items-center mt-4" };
const _hoisted_79 = ["disabled"];
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm mt-4" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "designated_operative_no",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_81 = {
    key: 2,
    class: "col-span-6 mt-4"
};
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "designated_operative_payroll",
    class: "block mt-4 text-sm font-medium text-gray-700"
}, "Please enter the designated operative's payroll number:\n                *", -1));
const _hoisted_83 = ["disabled"];
const _hoisted_84 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "designated_operative_name",
    class: "block mt-4 text-sm font-medium text-gray-700"
}, "Please enter the designated operative's name: *", -1));
const _hoisted_86 = ["disabled"];
const _hoisted_87 = {
    key: 1,
    class: "text-red-500"
};
const _hoisted_88 = {
    key: 3,
    class: "col-span-6 mt-4"
};
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "helpdesk_email",
    class: "text-sm font-medium text-gray-700"
}, "Please enter the relevant helpdesk email address: *", -1));
const _hoisted_90 = ["disabled"];
const _hoisted_91 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_92 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_93 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("fieldset", null, [
                    _hoisted_4,
                    _createTextVNode(),
                    (_ctx.v$.formData.employee_reporting_to.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "\n            * " + _toDisplayString(_ctx.v$.formData.employee_reporting_to.$errors[0].$message), 1))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "radio-button-employee_reporting_to-yes",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formData.employee_reporting_to) = $event)),
                                    value: "Yes",
                                    name: "employee_reporting_to",
                                    type: "radio",
                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.employee_reporting_to.$touch()))
                                }, null, 42, _hoisted_9), [
                                    [_vModelRadio, _ctx.formData.employee_reporting_to]
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_10
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "radio-button-employee_reporting_to-no",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.employee_reporting_to) = $event)),
                                        value: "No",
                                        name: "employee_reporting_to",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            }]),
                                        disabled: _ctx.disableForm,
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.employee_reporting_to.$touch()))
                                    }, null, 42, _hoisted_13), [
                                        [_vModelRadio, _ctx.formData.employee_reporting_to]
                                    ])
                                ]),
                                _createTextVNode(),
                                _hoisted_14
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _hoisted_15
                ]),
                _createTextVNode(),
                (_ctx.formData.employee_reporting_to === 'Yes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "line_manager_input",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.line_manager) = $event)),
                                type: "text",
                                name: "line_manager",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        'error-border': _ctx.v$.formData.line_manager.$error,
                                        'border-red-500': _ctx.v$.formData.line_manager.$error,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.line_manager.$touch()))
                            }, null, 42, _hoisted_20), [
                                [_vModelText, _ctx.formData.line_manager]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.line_manager.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "\n              * " + _toDisplayString(_ctx.v$.formData.line_manager.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "employee_number_input",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formData.employee_number) = $event)),
                                type: "text",
                                name: "employee_number",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        'error-border': _ctx.v$.formData.employee_number.$error,
                                        'border-red-500': _ctx.v$.formData.employee_number.$error,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.employee_number.$touch()))
                            }, null, 42, _hoisted_24), [
                                [_vModelText, _ctx.formData.employee_number]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.employee_number.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "\n              * " + _toDisplayString(_ctx.v$.formData.employee_number.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_28, [
                                _withDirectives(_createElementVNode("textarea", {
                                    id: "additional_information_input",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.formData.additional_information) = $event)),
                                    name: "additional_information",
                                    rows: "3",
                                    class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm
                                }, null, 10, _hoisted_29), [
                                    [_vModelText, _ctx.formData.additional_information]
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _hoisted_30
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _createElementVNode("fieldset", _hoisted_31, [
                    _hoisted_32,
                    _createTextVNode(),
                    (_ctx.v$.formData.coupa_user.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, "\n            * " + _toDisplayString(_ctx.v$.formData.coupa_user.$errors[0].$message), 1))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "radio-button-coupa_user-yes",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.formData.coupa_user) = $event)),
                                    value: "Yes",
                                    name: "coupa_user",
                                    type: "radio",
                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.v$.formData.coupa_user.$touch()))
                                }, null, 42, _hoisted_37), [
                                    [_vModelRadio, _ctx.formData.coupa_user]
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_38
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "radio-button-coupa_user-no",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.formData.coupa_user) = $event)),
                                        value: "No",
                                        name: "coupa_user",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            }]),
                                        disabled: _ctx.disableForm,
                                        onBlur: _cache[12] || (_cache[12] = ($event) => (_ctx.v$.formData.coupa_user.$touch()))
                                    }, null, 42, _hoisted_41), [
                                        [_vModelRadio, _ctx.formData.coupa_user]
                                    ])
                                ]),
                                _createTextVNode(),
                                _hoisted_42
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                (_ctx.formData.coupa_user === 'Yes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                            _hoisted_45,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "coupa_user_name_input",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.formData.coupa_user_name) = $event)),
                                type: "text",
                                name: "coupa_user_name",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        'error-border': _ctx.v$.formData.coupa_user_name.$error,
                                        'border-red-500': _ctx.v$.formData.coupa_user_name.$error,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[14] || (_cache[14] = ($event) => (_ctx.v$.formData.coupa_user_name.$touch()))
                            }, null, 42, _hoisted_46), [
                                [_vModelText, _ctx.formData.coupa_user_name]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.coupa_user_name.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, "\n              * " + _toDisplayString(_ctx.v$.formData.coupa_user_name.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "coupa_user_number_input",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.formData.coupa_user_number) = $event)),
                                type: "text",
                                name: "coupa_user_number",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        'error-border': _ctx.v$.formData.coupa_user_number.$error,
                                        'border-red-500': _ctx.v$.formData.coupa_user_number.$error,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[16] || (_cache[16] = ($event) => (_ctx.v$.formData.coupa_user_number.$touch()))
                            }, null, 42, _hoisted_50), [
                                [_vModelText, _ctx.formData.coupa_user_number]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.coupa_user_number.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_51, "\n              * " + _toDisplayString(_ctx.v$.formData.coupa_user_number.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "coupa_user_email_input",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.formData.coupa_user_email) = $event)),
                                type: "text",
                                name: "coupa_user_email",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        'error-border': _ctx.v$.formData.coupa_user_email.$error,
                                        'border-red-500': _ctx.v$.formData.coupa_user_email.$error,
                                    }]),
                                disabled: _ctx.disableForm,
                                onBlur: _cache[18] || (_cache[18] = ($event) => (_ctx.v$.formData.coupa_user_email.$touch()))
                            }, null, 42, _hoisted_54), [
                                [_vModelText, _ctx.formData.coupa_user_email]
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.coupa_user_email.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_55, "\n              * " + _toDisplayString(_ctx.v$.formData.coupa_user_email.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _createElementVNode("fieldset", _hoisted_56, [
                    _hoisted_57,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "radio-button-cafm_leaver-yes",
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.formData.cafm_leaver) = $event)),
                                    value: "Yes",
                                    name: "cafm_leaver",
                                    type: "radio",
                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[20] || (_cache[20] = ($event) => (_ctx.v$.formData.cafm_leaver.$touch()))
                                }, null, 42, _hoisted_61), [
                                    [_vModelRadio, _ctx.formData.cafm_leaver]
                                ])
                            ]),
                            _createTextVNode(),
                            _hoisted_62
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "radio-button-cafm_leaver-no",
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.formData.cafm_leaver) = $event)),
                                        value: "No",
                                        name: "cafm_leaver",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            }]),
                                        disabled: _ctx.disableForm,
                                        onBlur: _cache[22] || (_cache[22] = ($event) => (_ctx.v$.formData.cafm_leaver.$touch()))
                                    }, null, 42, _hoisted_65), [
                                        [_vModelRadio, _ctx.formData.cafm_leaver]
                                    ])
                                ]),
                                _createTextVNode(),
                                _hoisted_66
                            ])
                        ]),
                        _createTextVNode(),
                        (_ctx.formData?.cafm_leaver === 'Yes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _hoisted_68,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("input", {
                                    id: "cafm_leaver_contracts",
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.formData.cafm_leaver_contracts) = $event)),
                                    name: "cafm_leaver_contracts",
                                    type: "text",
                                    class: _normalizeClass(["mt-4 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            'error-border': _ctx.v$.formData.cafm_leaver_contracts.$error,
                                            'border-red-500': _ctx.v$.formData.cafm_leaver_contracts.$error,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[24] || (_cache[24] = ($event) => (_ctx.v$.formData.cafm_leaver_contracts.$touch()))
                                }, null, 42, _hoisted_69), [
                                    [_vModelText, _ctx.formData.cafm_leaver_contracts]
                                ]),
                                _createTextVNode(),
                                (_ctx.v$.formData.cafm_leaver_contracts.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_70, "\n                * " + _toDisplayString(_ctx.v$.formData.cafm_leaver_contracts.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.formData?.cafm_leaver_contracts)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _hoisted_72,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_73, [
                                    _createElementVNode("div", _hoisted_74, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "radio-button-designated_operative-yes",
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.formData.designated_operative_check) = $event)),
                                            value: "Yes",
                                            name: "designated_operative",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                }]),
                                            disabled: _ctx.disableForm,
                                            onBlur: _cache[26] || (_cache[26] = ($event) => (_ctx.v$.formData.cafm_leaver.$touch()))
                                        }, null, 42, _hoisted_75), [
                                            [_vModelRadio, _ctx.formData.designated_operative_check]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_76
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("div", _hoisted_78, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "radio-button-designated_operative-no",
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.formData.designated_operative_check) = $event)),
                                            value: "No",
                                            name: "designated_operative_check",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                }]),
                                            disabled: _ctx.disableForm,
                                            onBlur: _cache[28] || (_cache[28] = ($event) => (_ctx.v$.formData.cafm_leaver.$touch()))
                                        }, null, 42, _hoisted_79), [
                                            [_vModelRadio, _ctx.formData.designated_operative_check]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_80
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.formData?.designated_operative_check === 'Yes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                _hoisted_82,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("input", {
                                    id: "designated_operative_payroll",
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.formData.designated_operative_payroll) = $event)),
                                    name: "designated_operative_payroll",
                                    type: "text",
                                    class: _normalizeClass(["mt-4 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[30] || (_cache[30] = ($event) => (_ctx.v$.formData.designated_operative_payroll.$touch()))
                                }, null, 42, _hoisted_83), [
                                    [_vModelText, _ctx.formData.designated_operative_payroll]
                                ]),
                                _createTextVNode(),
                                (_ctx.v$.formData.designated_operative_payroll.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_84, "\n                *\n                " + _toDisplayString(_ctx.v$.formData.designated_operative_payroll.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _hoisted_85,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("input", {
                                    id: "designated_operative_name",
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((_ctx.formData.designated_operative_name) = $event)),
                                    name: "designated_operative_name",
                                    type: "text",
                                    class: _normalizeClass(["mt-4 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[32] || (_cache[32] = ($event) => (_ctx.v$.formData.designated_operative_name.$touch()))
                                }, null, 42, _hoisted_86), [
                                    [_vModelText, _ctx.formData.designated_operative_name]
                                ]),
                                _createTextVNode(),
                                (_ctx.v$.formData.designated_operative_name.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_87, "\n                *\n                " + _toDisplayString(_ctx.v$.formData.designated_operative_name.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.formData?.cafm_leaver === 'Yes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _hoisted_89,
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("input", {
                                    id: "helpdesk_email",
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((_ctx.formData.helpdesk_email) = $event)),
                                    name: "helpdesk_email",
                                    type: "email",
                                    class: _normalizeClass(["mt-4 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                            'error-border': _ctx.v$.formData.helpdesk_email.$error,
                                            'border-red-500': _ctx.v$.formData.helpdesk_email.$error,
                                        }]),
                                    disabled: _ctx.disableForm,
                                    onBlur: _cache[34] || (_cache[34] = ($event) => (_ctx.v$.formData.helpdesk_email.$touch()))
                                }, null, 42, _hoisted_90), [
                                    [_vModelText, _ctx.formData.helpdesk_email]
                                ]),
                                _createTextVNode(),
                                (_ctx.v$.formData.helpdesk_email.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_91, "\n                * " + _toDisplayString(_ctx.v$.formData.helpdesk_email.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[35] || (_cache[35] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_93)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
